module.exports = __webpack_public_path__ + "assets/img/Pioneer_Sevestre.b12bf1b9-ps.jpg";